import './whatsapp_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappTextMessageContent extends Monitoring.Models.SocialContents.WhatsappMessageContent

  getMainText: ->
    text = @json.whatsappMessage.body
    text.replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;')
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;")
    
